import {
  InputNumber,
  InputNumberProps,
} from 'antd';
import { formatUnits } from 'ethers';

import BalanceCom from '@/components/BalanceCom';
import Icon from '@/components/Icon';
import LpTokenImg from '@/components/LpTokenImg';
import bankCard from '@/image/bankCard.svg';

const InputLp = ({ tokenBalance, tokenBalanceLod, value, setAmount, fromTokenLogo, toTokenLogo, fromSymbol, toSymbol }: { setAmount: Function, value: string, tokenBalance: bigint, tokenBalanceLod: boolean, fromTokenLogo: string, toTokenLogo: string, fromSymbol: string, toSymbol: string }) => {
    // 用户输入兑换数量（限制为最多 6 位小数）
    const onChange: InputNumberProps['onChange'] = (value) => {
        const strValue = typeof value === 'string' ? value : String(value ?? '');
        if (strValue === '0') return setAmount('');
        setAmount(strValue);
    };
    return (
        <>
            <div className="p-2.5 bg-white rounded-5  border border-ee text-mainBlack">
                <div className="flex items-center justify-between mb-1.75">
                    <div className="text-a8 text-sm">输入</div>
                    <div className="text-a8 text-xs flex items-center">
                        <Icon src={bankCard} className="w-3 mr-1" />
                        <BalanceCom balance={tokenBalance} loading={tokenBalanceLod} />
                        {/* MAX 按钮：点击时自动填入最大可用余额 */}
                        <span
                            onClick={() => tokenBalance && onChange(formatUnits(tokenBalance))}
                            className="pl-1.25 cursor-pointer underline text-00b decoration-00b"
                        >
                            MAX
                        </span>
                    </div>
                </div>
                <div className='flex items-center justify-between'>
                    <InputNumber
                        max={formatUnits(tokenBalance)}
                        value={value || ''}
                        controls={false}
                        stringMode
                        onChange={onChange}
                        className="w-full text-6.5 font-medium mr-2 "
                        size="large"
                    />
                    <div
                        className="box-border px-2.5 py-1.5 flex items-center border rounded-5 border-e2 cursor-pointer"
                    >
                        <LpTokenImg className='w-6 min-w-6 mr-4' fromTokenLogo={fromTokenLogo} toTokenLogo={toTokenLogo} />
                        <span className="text-1d text-sm mr-2.5">{fromSymbol}/{toSymbol}</span>
                    </div>
                </div>
            </div>
        </ >
    )
}

export default InputLp